export default "__VITE_ASSET__U$y1d91$__"